export default __webpack_public_path__ + "static/media/L0003.6d272325.png";